import { render, staticRenderFns } from "./base-icon.vue?vue&type=template&id=46222e07&scoped=true&"
import script from "./base-icon.vue?vue&type=script&lang=js&"
export * from "./base-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../WebVR/webvr-infest/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46222e07",
  null
  
)

export default component.exports